module.exports = __webpack_public_path__ + "img/icon-sent-message.bd6f608f.svg";